import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {PopupService} from '../../../services/shared/popup.service';
import {ApplicationService} from '../../../services/application.service';
import {UtilityServiceService} from '../../../services/utility-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PermitService} from '../../../services/permit.service';
import {AuthWebService} from '../../../services/authweb.service';
import {VehicleService} from '../../../services/vehicle.service';
import {ToastNotificationService} from '../../../shared/toast-notification/toast-notification.service';
import {PlaceService} from '../../../services/place.service';
import {DocumenttypeService} from '../../../services/documenttype.service';
import {TimetableService} from '../../../services/timetable.service';
import {RouteService} from '../../../services/route.service';
import {CountryService} from '../../../services/country.service';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../environments/environment';
import html2canvas from 'html2canvas';
import {ConfirmDialogService} from '../../../services/shared/confirm-dialog/confirm-dialog.service';

@Component({
    selector: 'app-permit-timetable',
    templateUrl: './permit-timetable.component.html',
    styleUrls: ['./permit-timetable.component.css']
})


export class PermitTimetableComponent implements OnInit {
@Input() dataCntrl: any;
    timeTableList: any = [];
    isLoading = false;
    message = "Loading timetables, please wait...";
    departuresList: any = [];
    departuresListRemove: any = [];
    editFlag: boolean = false;
    pageload: boolean = false;
    showBlock: boolean = false;
    isDuplicateMode: boolean = false;
    isProcess:boolean=true;

    selectedTimetable:any;
    @Output() previousStep = new EventEmitter<number>();
    @Input() isEditing: boolean = true;
    goBack() {
        this.previousStep.emit(5);
    }
    @Output() nextStep = new EventEmitter<number>();
    isExternalRole: boolean = true;
    goNextStep() {
        this.nextStep.emit(5)
    }

    constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
        private showModal: PopupService, public applicationService: ApplicationService,
        private utility: UtilityServiceService,private toastService:ToastNotificationService,
        private router: Router, private permitService: PermitService,
        private vehicleService: VehicleService,private authWebService: AuthWebService,
        private activeRoute: ActivatedRoute, private placeService: PlaceService,private confirmDialogService: ConfirmDialogService,
        private documenttypeService: DocumenttypeService, private timetblSrc: TimetableService,
        private routeService: RouteService, private countryService: CountryService, private datePipe: DatePipe) {
        this.toastr.clear();

    }

    ngOnInit() {
        this.dataCntrl.timeTableList=[];
        this.isDuplicateMode = this.router.url.indexOf('duplicate') > 0;
        if (this.router.url.indexOf('view') > 0) {
            this.isProcess=false;
        }

        console.log(this.dataCntrl.application.route_id);
        this.getTimeTable('load');

        if(!this.authWebService.userData.Roles[0].IsExternalRole){
            this.isExternalRole = false;
        }

    }

    isReturnTimetable: boolean = false;
    timeTableIndex: number = 0;
    addNew() {
        this.dataCntrl.timeId = 0;
        this.dataCntrl.index = (this.timeTableList) ? this.timeTableList.length + 1 : 1;
        console.log('Index 1= ', this.dataCntrl.index);
        this.dataCntrl.isReturned = false;
        console.log('TimeTableList = ', this.timeTableList);
        this.onShow();
    }

    getTimeTable(loadType) {

        if (this.dataCntrl.application.route_id != null && this.dataCntrl.application.route_id != '') {
            this.onSwitchOnOrOff(true);
            this.routeService.listRouteTimetables(this.dataCntrl.application.route_id).subscribe(res => {
                const rsrc: any = res;
                this.timeTableList = rsrc.listTimetables;
                console.log('TimeTableList = ', this.timeTableList);
                this.dataCntrl.timeTableList=this.timeTableList;
                this.onSwitchOnOrOff();
                for (let list of this.timeTableList) {
                    list.latestRecord = false;
                    list.showBlock = false;
                }
                if (this.timeTableList.length > 0 && loadType != 'load') {
                    let count: any = this.timeTableList.length - 1;
                    this.timeTableList[count].latestRecord = true;
                    if (loadType != 'save') {
                        setTimeout(() => { $("#table-record-" + count).click(); }, 200);
                    }
                }
            }, error => {
                this.onSwitchOnOrOff();
                this.toastService.error('Failed to load timetables. If the problem persists, please contact system administrator.', 'Load Timetables');

            });
        }
    }

    onMenuChange = (key, timeId, ctrl, index) => {

        this.dataCntrl.timeId = timeId;
        switch (key) {
            case 'edit':
                this.dataCntrl.isReturned = false;
                this.onShow();
                break;
            case 'return':
                this.dataCntrl.isReturned = true;
                this.dataCntrl.index = index;
                this.onShow();
                break;
            case 'delete':
                this.onDeleteTimetable(timeId);
                break;
            case 'edit-detail':
                $("#table-record-" + index).click();
                break;
            default:
                break;
        }
        if(ctrl != null)
        $(ctrl).val('null');

    }

    onClose = () => {
        this.dataCntrl.timeId = 0;
        // $("#Manager").modal('hide');
        document.getElementById('secretButton').click();
    }

    onShow = () => {
        // $("#Manager").modal();
        document.getElementById('secretButton').click();
    }

    isForward = (type: string) => {
        return type == "Forward";
    }

    onSwitchOnOrOff = (state = false) => {
        this.isLoading = state;
    }

    onDeleteTimetable = (id) => {

        this.confirmDialogService.confirmThis('Are you sure you want to delete this timetable?',
            () => {
                this.onSwitchOnOrOff(true);
                this.message = 'Deleting timetable, please wait...';
                this.timetblSrc.delete(id).subscribe((rsrc:any) => {

                    this.onSwitchOnOrOff();
                    if (rsrc.isDeleted) {
                        this.getTimeTable('load');
                        this.toastService.success('Delete Timetable', 'Timetable deleted successfully');
                    } else {
                        this.toastService.error('Failed to delete timetable. If the problem persists, please contact system administrator.', 'Delete Timetable');
                    }
                }, error => {
                    this.onSwitchOnOrOff();
                    this.toastService.error('Failed to delete timetables. If the problem persists, please contact system administrator.', 'Delete Timetables');
                });

            }, () =>  {
                //No here

            })

        // this.showModal.showYesNo('Delete Timetable', 'Are you sure you want to delete this timetable?', 'The deletion is permenant.').subscribe(isConfirmed => {
        //     if (isConfirmed) {
        //
        //     }
        // });
    }
    showDepartures(list, index, event) {
        if (event != "" && event.target.nodeName == 'SELECT') {
            return false;
        }
        if (!list.showBlock) {
            this.routeService.getTableDepartures(list.id).subscribe(res => {
                this.departuresList = [];
                this.departuresList = res;
                let count: any = 0;
                if (this.departuresList.length > 0) {
                    let lastDuplicateRow: any = "";
                    if (list.timetable_direction == 'Forward') {
                        lastDuplicateRow = JSON.parse(JSON.stringify(this.departuresList[this.departuresList.length - 1]));
                        this.departuresList.push(lastDuplicateRow);
                    } else {
                        let array: any = [];
                        lastDuplicateRow = JSON.parse(JSON.stringify(this.departuresList[0]));
                        array.push(lastDuplicateRow);
                        this.departuresList = array.concat(this.departuresList);
                    }
                    if (list.timetable_direction == 'Forward') {
                        for (let list of this.departuresList) {
                            list.travalTime = 0;
                            list.departTime = 0;
                            list.travelStop = 0;
                            list.orgtype_of_stop = list.type_of_stop;
                            list.orgDistance = list.distance;
                            list.orgArrivalTime = list.arrive_time;
                            list.showArrive = false;
                            list.showDepart = false;
                            list.errorFlag = false;
                            list.departError = false;
                            if (count != 0) {
                                list.type_of_stop = this.departuresList[count - 1].orgtype_of_stop;
                                list.distance = this.departuresList[count - 1].orgDistance;
                                list.arrive_time = this.departuresList[count - 1].orgArrivalTime;
                            }
                            let item: any = this.utility.listStops.filter((map) => { return map.key == list.type_of_stop });
                            if (item != null && item.length > 0) {
                                list.stop = item[0].value;
                            } else {
                                list.stop = "";
                            }
                            this.caluculateTravel(list, count);
                            this.caluculateDepart(list, count);
                            count++;
                        }
                    } else {
                        count = 0;
                        for (let list of this.departuresList) {
                            list.orgtype_of_stop = list.type_of_stop;
                            if (count != this.departuresList.length - 1) {
                                list.depart_time = this.departuresList[count + 1].depart_time;
                                list.type_of_stop = this.departuresList[count + 1].type_of_stop;
                            }
                            this.caluculateTravel(list, count);
                            this.caluculateDepart(list, count);
                            count++;
                        }
                    }
                    this.departuresList[0].type_of_stop = 1;
                    this.departuresList[0].distance = 0;
                    this.departuresList[this.departuresList.length - 1].type_of_stop = 9;

                }
                this.editFlag = false;
                $(".table-record").hide();
                $("#table-record-" + index).show();
                list.showBlock = true;
            });
            list.showBlock = true;

        } else {
            list.showBlock = false;
            $(".table-record").show();
        }

        this.selectedTimetable = list;
    }

    closeDepartue() {
        $(".table-record").show();
        $(".departure-data").hide();
    }
    editDeparture(list, index) {
        this.editFlag = true;
        this.showDepartures(list, index, '');
    }
    saveDeparture(direction) {
        let count: any = 0;
        let newArr = [];
        for (let list of this.departuresList) {
            list.duration = this.getTotalDurationTime(list, 'travalTime', 'departTime');
            //console.log(list.duration);
        }
        for (let list of this.departuresList) {
            if (direction == 'Forward') {
                if (count != this.departuresList.length - 1) {
                    list.distance = this.departuresList[count + 1].distance;
                    list.arrive_time = this.departuresList[count + 1].arrive_time;
                    list.type_of_stop = this.departuresList[count + 1].type_of_stop;
                    list.duration = this.departuresList[count + 1].duration;
                }
            } else {
                list.orgDepart_time = list.depart_time;
                list.orgtype_of_stop = list.type_of_stop
                if (count != 0) {
                    list.depart_time = this.departuresList[count - 1].orgDepart_time;
                    list.type_of_stop = this.departuresList[count - 1].orgtype_of_stop;
                    newArr.push(list);
                }
            }
            if (list.arrive_time != null && list.arrive_time != '' && list.arrive_time.split(":")[0] == '24') {
                let time: any = list.arrive_time.split(":");
                time[0] = "00";
                list.arrive_time = time.join(":");
            }
            if (list.depart_time != null && list.depart_time != '' && list.depart_time.split(":")[0] == '24') {
                let time: any = list.depart_time.split(":");
                time[0] = "00";
                list.depart_time = time.join(":");
            }
            count++;
        }
        if (direction == 'Forward') {
            this.departuresList.forEach((item, index) => {
                if (newArr.findIndex(i => i.route_leg_id == item.route_leg_id) === -1) {
                    newArr.push(item)
                }
            });
        }
        this.departuresList = newArr;
        console.log(this.departuresList);
        console.log('list saved');



        this.editFlag = true;
        this.routeService.updateTimetable(this.departuresList).subscribe((res) => {
            console.log(res);
            this.toastService.success('Saved  Timetable', 'Timetable saved successfully');
            this.closeDepartue();
            this.getTimeTable('save');
        });

    }
    getTotalDistance() {
        let totalDistance: any = 0;
        for (let list of this.departuresList) {
            if (list.distance != "") {
                totalDistance = totalDistance + parseInt(list.distance);
            }
        }
        return totalDistance;
    }
    getTotalArrivalTime(arrivalTime) {
        let totalTime: any = 0;
        let totalHours: any = 0;
        let totalMinutes: any = 0;
        let seperator: any = ":"
        for (let list of this.departuresList) {
            if (list[arrivalTime] != null && list[arrivalTime] != "" && list[arrivalTime] != undefined) {
                let hours: any = 0;
                if (list[arrivalTime].includes(".")) {
                    seperator = ".";
                }
                if (list[arrivalTime].includes(":")) {
                    seperator = ":";
                }
                if (list[arrivalTime].includes(":") || list[arrivalTime].includes(".")) {
                    hours = list[arrivalTime].split(seperator)[0];
                } else {
                    hours = list[arrivalTime];
                }
                if (hours != undefined && hours != null && hours != "") {
                    totalHours = totalHours + parseInt(hours);
                }
                let minutes: any = 0;
                if (list[arrivalTime].includes(":") || list[arrivalTime].includes(".")) {
                    minutes = list[arrivalTime].split(seperator)[1];
                } else {
                    minutes = 0;
                }
                if (minutes != undefined && minutes != null && minutes != "") {
                    totalMinutes = totalMinutes + parseInt(minutes);
                }
            }
        }
        if (totalMinutes == 0) {
            totalMinutes = "00";
        }
        let dayHours: any = 0;
        let dayMinutes: any = 0;
        if (totalHours >= 24) {
            let val: any = totalHours / 24;
            dayHours = parseInt(val) * 24;
            totalHours = totalHours - dayHours;
        }
        if (totalMinutes >= 60) {
            let val: any = totalMinutes / 60;
            dayMinutes = parseInt(val) * 60;
            totalMinutes = totalMinutes - dayMinutes;
            dayHours = dayHours + parseInt(val);
        }
        let currentDate = new Date();
        let arrivalDate: any = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate(), totalHours, totalMinutes, 0);
        let hours: any = arrivalDate.getHours() + dayHours;
        let minutes: any = arrivalDate.getMinutes();
        let seconds: any = arrivalDate.getSeconds();
        hours = hours >= 10 ? hours : "0" + hours;
        minutes = minutes >= 10 ? minutes : "0" + minutes;
        seconds = seconds >= 10 ? seconds : "0" + seconds;
        //console.log("conert to time-------------------" + hours + ":" + minutes + ":" + seconds);
        totalTime = hours + ":" + minutes + ":" + seconds;
        //totalTime=totalHours+":"+totalMinutes;
        return totalTime;
    }
    getTotalDepartTime(arrivalTime) {
        let totalTime: any = 0;
        let totalHours: any = 0;
        let totalMinutes: any = 0;
        let seperator: any = ":"
        for (let list of this.departuresList) {
            if (list[arrivalTime] != null && list[arrivalTime] != "" && list[arrivalTime] != undefined) {
                let hours: any = 0;
                if (list[arrivalTime].includes(".")) {
                    seperator = ".";
                }
                if (list[arrivalTime].includes(":")) {
                    seperator = ":";
                }
                if (list[arrivalTime].includes(":") || list[arrivalTime].includes(".")) {
                    hours = list[arrivalTime].split(seperator)[0];
                } else {
                    hours = list[arrivalTime];
                }
                if (hours != undefined && hours != null && hours != "") {
                    totalHours = totalHours + parseInt(hours);
                }
                let minutes: any = 0;
                if (list[arrivalTime].includes(":") || list[arrivalTime].includes(".")) {
                    minutes = list[arrivalTime].split(seperator)[1];
                } else {
                    minutes = 0;
                }
                if (minutes != undefined && minutes != null && minutes != "") {
                    totalMinutes = totalMinutes + parseInt(minutes);
                }
            }
        }
        if (totalMinutes == 0) {
            totalMinutes = "00";
        }
        let dayHours: any = 0;
        let dayMinutes: any = 0;
        if (totalHours >= 24) {
            let val: any = totalHours / 24;
            dayHours = parseInt(val) * 24;
            totalHours = totalHours - dayHours;
        }
        if (totalMinutes >= 60) {
            let val: any = totalMinutes / 60;
            dayMinutes = parseInt(val) * 60;
            totalMinutes = totalMinutes - dayMinutes;
            dayHours = dayHours + parseInt(val);
        }
        let currentDate = new Date();
        let arrivalDate: any = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate(), totalHours, totalMinutes, 0);
        let hours: any = arrivalDate.getHours() + dayHours;
        let minutes: any = arrivalDate.getMinutes();
        let seconds: any = arrivalDate.getSeconds();
        hours = hours >= 10 ? hours : "0" + hours;
        minutes = minutes >= 10 ? minutes : "0" + minutes;
        seconds = seconds >= 10 ? seconds : "0" + seconds;
        //console.log("conert to time-------------------" + hours + ":" + minutes + ":" + seconds);
        totalTime = hours + ":" + minutes + ":" + seconds;
        //totalTime=totalHours+":"+totalMinutes;
        return totalTime;
    }
    validateInput(item, index) {
        this.caluculateTravel(item, index);
        if (item.errorFlag) {
            this.toastService.error("Please check arrive time.",'')
        }
    }
    validateDepartInput(item, index) {
        this.caluculateDepart(item, index)
        if (item.departError) {
            this.toastService.error("Please check depart time.", '')
        }
    }
    caluculateTravel(item, index) {
        let travalTime: any = 0;
        let arriveHours: any = 0;
        let arriveMinutes: any = 0;
        let departHours: any = 0;
        let departMinutes: any = 0;
        if (index != 0) {
            if ((item['arrive_time'] == null || item['arrive_time'] == "") && (this.departuresList[index - 1]['depart_time'] == null || this.departuresList[index - 1]['depart_time'] == "")) {
                return false;
            }
            if (item['arrive_time'] != null && item['arrive_time'] != "" && item['arrive_time'] != undefined) {
                let seperator: any = ":";
                if (item['arrive_time'].includes(".")) {
                    seperator = ".";
                }
                if (item['arrive_time'].includes(":")) {
                    seperator = ":";
                }
                if (item['arrive_time'].includes(":") || item['arrive_time'].includes(".")) {
                    arriveHours = item['arrive_time'].split(seperator)[0];
                    if (item['arrive_time'].split(seperator)[1] != "" && item['arrive_time'].split(seperator)[1] != null && item['arrive_time'].split(seperator)[1] != undefined) {
                        arriveMinutes = item['arrive_time'].split(seperator)[1];
                    }
                } else {
                    arriveHours = item['arrive_time'];
                    arriveMinutes = 0;
                }
            }
            if (this.departuresList[index - 1]['depart_time'] != null && this.departuresList[index - 1]['depart_time'] != undefined && this.departuresList[index - 1]['depart_time'] != "") {
                let seperator: any = ":";
                if (this.departuresList[index - 1]['depart_time'].includes(".")) {
                    seperator = ".";
                }
                if (this.departuresList[index - 1]['depart_time'].includes(":")) {
                    seperator = ":";
                }
                if (this.departuresList[index - 1]['depart_time'].includes(":") || this.departuresList[index - 1]['depart_time'].includes(".")) {
                    departHours = this.departuresList[index - 1]['depart_time'].split(seperator)[0];
                    departMinutes = this.departuresList[index - 1]['depart_time'].split(seperator)[1];
                    if (departMinutes == "" || departMinutes == null || departMinutes == undefined) {
                        departMinutes = 0;
                    }
                } else {
                    departHours = this.departuresList[index - 1]['depart_time'];
                    departMinutes = 0;
                }
            }
        } else {
            return false;
        }
        let tlMinutes: any = (parseInt(arriveMinutes) - parseInt(departMinutes));
        if (tlMinutes == 0) {
            tlMinutes = "00"
        }
        if (departHours == "") {
            departHours = 0;
        }
        if (arriveHours == "") {
            arriveHours = 0;
        }
        if (arriveHours == 24) {
            arriveHours = 0;
        }
        if (departHours == 24) {
            departHours = 0;
        }
        //if(arriveHours!=0){
        //travalTime=(parseInt(arriveHours)-parseInt(departHours))+":"+tlMinutes;

        let arriveSeconds: any = 0
        let currentDate: any = new Date();
        let arrivalDate: any = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate(), arriveHours, arriveMinutes, arriveSeconds);
        let departDate: any = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate(), departHours, departMinutes, arriveSeconds);
        let time: any = 0;
        if (arrivalDate.getTime() > departDate.getTime()) {
            time = arrivalDate.getTime() - departDate.getTime();
            item.showArrive = false;
        } else {
            arrivalDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate() + 1, arriveHours, arriveMinutes, arriveSeconds);
            time = arrivalDate.getTime() - departDate.getTime();
            let tr1Time: any = new Date(time);
            let hours1: any = Math.floor(time / 1000 / 60 / 60);
            if (hours1 < 9) {
                item.showArrive = true;
                item.errorFlag = false;
            } else {
                // this.toastr.error("Please check arrival time.");
                item.showArrive = false;
                item.errorFlag = true;
            }
        }
        let trTime: any = new Date(time);
        let hours: any = Math.floor(time / 1000 / 60 / 60);
        time -= hours * 1000 * 60 * 60;
        if (hours < 9) {
            item.errorFlag = false;
        } else {
            item.errorFlag = true;
        }
        let minutes: any = Math.floor(time / 1000 / 60);
        time -= minutes * 1000 * 60;
        let seconds: any = Math.floor(time / 1000);
        hours = hours >= 10 ? hours : "0" + hours;
        minutes = minutes >= 10 ? minutes : "0" + minutes;
        seconds = seconds >= 10 ? seconds : "0" + seconds;
        console.log("conert to time-------------------" + hours + ":" + minutes + ":" + seconds);
        travalTime = hours + ":" + minutes + ":" + seconds;
        //}
        item.travalTime = travalTime;
        item.duration = travalTime;
        return travalTime;
    }
    caluculateDepart(item, index) {
        let departTime: any = 0;
        let arriveHours: any = 0;
        let arriveMinutes: any = 0;
        let departHours: any = 0;
        let departMinutes: any = 0;
        if (index != 0 && index != this.departuresList.length - 1) {
            if ((item['arrive_time'] == null || item['arrive_time'] == "") && (item['depart_time'] == null || item['depart_time'] == "")) {
                return false;
            }
            if (item['arrive_time'] != null && item['arrive_time'] != "") {
                let seperator: any = ":";
                if (item['arrive_time'].includes(".")) {
                    seperator = ".";
                }
                if (item['arrive_time'].includes(":")) {
                    seperator = ":";
                }
                if (item['arrive_time'].includes(":") || item['arrive_time'].includes(".")) {
                    arriveHours = item['arrive_time'].split(seperator)[0];
                    if (item['arrive_time'].split(seperator)[1] != "" && item['arrive_time'].split(seperator)[1] != undefined && item['arrive_time'].split(seperator)[1] != null) {
                        arriveMinutes = item['arrive_time'].split(seperator)[1];
                    }
                } else {
                    arriveHours = item['arrive_time'];
                    arriveMinutes = 0;
                }
            }
            if (item['depart_time'] != null && item['depart_time'] != "") {
                let seperator: any = ":";
                if (item['depart_time'].includes(".")) {
                    seperator = ".";
                }
                if (item['depart_time'].includes(":")) {
                    seperator = ":";
                }
                if (item['depart_time'].includes(":") || item['depart_time'].includes(".")) {
                    departHours = item['depart_time'].split(seperator)[0];
                    if (item['depart_time'].split(seperator)[1] != "" && item['depart_time'].split(seperator)[1] != undefined && item['depart_time'].split(seperator)[1] != null) {
                        departMinutes = item['depart_time'].split(seperator)[1];
                    }
                } else {
                    departHours = item['depart_time'];
                    departMinutes = 0;
                }
            }
        } else {
            return false;
        }
        let tlMinutes: any = (parseInt(departMinutes) - parseInt(arriveMinutes));
        if (tlMinutes == 0) {
            tlMinutes = "00"
        }
        if (departHours == "") {
            departHours = 0;
        }
        if (arriveHours == "") {
            arriveHours = 0;
        }
        if (arriveHours == 24) {
            arriveHours = 0;
        }
        if (departHours == 24) {
            departHours = 0;
        }
        //if(departHours!=0){
        let arriveSeconds: any = 0;
        let currentDate: any = new Date();
        let arrivalDate: any = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate(), arriveHours, arriveMinutes, arriveSeconds);
        let departDate: any = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate(), departHours, departMinutes, arriveSeconds);
        let time: any = 0;
        if (departDate.getTime() > arrivalDate.getTime()) {
            time = departDate.getTime() - arrivalDate.getTime();
            item.showDepart = false;
        } else {
            departDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate() + 1, departHours, departMinutes, arriveSeconds);
            time = departDate.getTime() - arrivalDate.getTime();
            let tr1Time: any = new Date(time);
            let hours1: any = Math.floor(time / 1000 / 60 / 60);
            if (hours1 < 9) {
                item.showDepart = true;
                item.departError = false;
            } else {
                //this.toastr.error("Please check depart time.");
                item.showDepart = false;
                item.departError = true;
            }
        }
        let trTime: any = new Date(time);
        let hours: any = Math.floor(time / 1000 / 60 / 60);
        if (hours < 9) {
            item.departError = false;
        } else {
            item.departError = true;
        }
        time -= hours * 1000 * 60 * 60;
        let minutes: any = Math.floor(time / 1000 / 60);
        time -= minutes * 1000 * 60;
        let seconds: any = Math.floor(time / 1000);
        hours = hours >= 10 ? hours : "0" + hours;
        minutes = minutes >= 10 ? minutes : "0" + minutes;
        seconds = seconds >= 10 ? seconds : "0" + seconds;
        console.log("conert to time-------------------" + hours + ":" + minutes + ":" + seconds);
        departTime = hours + ":" + minutes + ":" + seconds;
        //departTime=(parseInt(departHours)-parseInt(arriveHours))+":"+tlMinutes;
        //}
        item.travelStop = departTime;
        item.departTime = departTime;
        return departTime;
    }
    saveTable() {
        if(this.timeTableList.length == 0){
            this.toastService.error('Cannot save & continue. Please ensure that you have created a timetable', 'Return Timetable')
            return;
        }

        if (!this.doAllReturns()) {
            this.toastService.error('Cannot save & continue. Please ensure that each forward timetable has a return timetable created', 'Return Timetable')
            return;
        }
        if (this.router.url.indexOf('duplicate') > 0 && this.router.url.indexOf('edit') < 0) {
            console.log("duplicated");
            console.log(this.dataCntrl.application);
            this.applicationService.putApplicationDuplicate(this.dataCntrl.application)
                .subscribe((result:any) => {
                        this.dataCntrl.application = result;
                        // this.saveDepatureDestination();
                        this.toastService.success('Duplicate Application', 'Application duplicated successfully');
                        let url: any = "carrier/permit/application/duplicate/edit/" + result.id;
                        this.router.navigate([url]);
                        return;
                    },
                    error => {
                        this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

                        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                        return;
                    });
        }
        // if (this.router.url.indexOf('correction') > 0) {
        //     return this.applicationService.setTab(7);
        // } else {
        //     this.applicationService.setTab(6);
        // }
        this.goNextStep();
    }
    cancelApplication() {
        // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
        //     this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
        // } else {
        //     this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
        //         .subscribe((isConfirmed) => {
        //             if (isConfirmed) {
        //                 this.deleteApplication()
        //             } else {
        //                 return;
        //             }
        //         });
        // }
        let prevUrl = localStorage.getItem('previousUrl');
        if (prevUrl.search('/permit/approval') != -1) {
            this.router.navigate(['/permit/approval/']);
        } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
            this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
        } else {
            this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
        }
    }
    deleteApplication() {
        console.log("delete application");
        this.pageload = true;

        this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x => {
            console.log(x);
            this.deleteApp(this.dataCntrl.application.id);
            this.pageload = false;

            this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);

        })
        //this.dataCntrl.application.id
        //this.dataCntrl.permit.id
    }
    deletePermit(id) {
        this.permitService.deletePermit(id).subscribe(x => {
            console.log(x);
        })

    }
    deleteApp(id) {
        this.applicationService.deleteApplication(id).subscribe(x => {
            console.log(x);
        })
    }
    numberOnly(event) {
        const charcode = (event.which) ? event.which : event.keyCode;
        if (charcode > 32 && (charcode < 48 || charcode > 57)) {
            return false;
        }
        return true;
    }
    getTotalDurationTime(list, arrivalTime, departTime) {
        let totalTime: any = 0;
        let totalHours: any = 0;
        let totalMinutes: any = 0;
        let seperator: any = ":";
        let arriveMinutes: any = 0;
        let arriveHours: any = 0;
        let stopMinutes: any = 0;
        let stopHours: any = 0;
        if (list[arrivalTime] != null && list[arrivalTime] != "" && list[arrivalTime] != undefined) {

            if (list[arrivalTime].includes(".")) {
                seperator = ".";
            }
            if (list[arrivalTime].includes(":")) {
                seperator = ":";
            }
            if (list[arrivalTime].includes(":") || list[arrivalTime].includes(".")) {
                arriveHours = list[arrivalTime].split(seperator)[0];
            } else {
                arriveHours = list[arrivalTime];
            }


            if (list[arrivalTime].includes(":") || list[arrivalTime].includes(".")) {
                arriveMinutes = list[arrivalTime].split(seperator)[1];
            } else {
                arriveMinutes = 0;
            }

        }
        if (list[departTime] != null && list[departTime] != "" && list[departTime] != undefined) {

            if (list[departTime].includes(".")) {
                seperator = ".";
            }
            if (list[departTime].includes(":")) {
                seperator = ":";
            }
            if (list[departTime].includes(":") || list[departTime].includes(".")) {
                stopHours = list[departTime].split(seperator)[0];
            } else {
                stopHours = list[departTime];
            }


            if (list[departTime].includes(":") || list[departTime].includes(".")) {
                stopMinutes = list[departTime].split(seperator)[1];
            } else {
                stopMinutes = 0;
            }

        }
        if (arriveHours != undefined && arriveHours != null && arriveHours != "") {
            totalHours = totalHours + parseInt(arriveHours);
        }
        if (arriveMinutes != undefined && arriveMinutes != null && arriveMinutes != "") {
            totalMinutes = totalMinutes + parseInt(arriveMinutes);
        }
        if (stopHours != undefined && stopHours != null && stopHours != "") {
            totalHours = totalHours + parseInt(stopHours);
        }
        if (stopMinutes != undefined && stopMinutes != null && stopMinutes != "") {
            totalMinutes = totalMinutes + parseInt(stopMinutes);
        }
        if (totalMinutes == 0) {
            totalMinutes = "00";
        }
        let dayHours: any = 0;
        let dayMinutes: any = 0;
        if (totalHours >= 24) {
            let val: any = totalHours / 24;
            dayHours = parseInt(val) * 24;
            totalHours = totalHours - dayHours;
        }
        if (totalMinutes >= 60) {
            let val: any = totalMinutes / 60;
            dayMinutes = parseInt(val) * 60;
            totalMinutes = totalMinutes - dayMinutes;
            dayHours = dayHours + parseInt(val);
        }
        let currentDate = new Date();
        let arrivalDate: any = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate(), totalHours, totalMinutes, 0);
        let hours: any = arrivalDate.getHours() + dayHours;
        let minutes: any = arrivalDate.getMinutes();
        let seconds: any = arrivalDate.getSeconds();
        hours = hours >= 10 ? hours : "0" + hours;
        minutes = minutes >= 10 ? minutes : "0" + minutes;
        seconds = seconds >= 10 ? seconds : "0" + seconds;
        console.log("conert to time-------------------" + hours + ":" + minutes + ":" + seconds);
        totalTime = hours + ":" + minutes + ":" + seconds;
        //totalTime=totalHours+":"+totalMinutes;
        return totalTime;
    }
    getTotalCtime(totalTime) {
        let tlTime: any = "";
        if (totalTime != null && totalTime != undefined && totalTime != "") {
            tlTime = 0;
            let time: any = totalTime.split(":");
            if (totalTime.includes(".")) {
                let dayHours = parseInt(time[0].split(".")[0]) * 24;
                let hours: any = parseInt(time[0].split(".")[1]) + dayHours;
                tlTime = hours + ":" + time[1] + ":" + time[2];
            } else {
                tlTime = totalTime;
            }
        }
        return tlTime;
    }
    backToTab() {
        this.applicationService.setTab(4);
    }

    showStopType = (item, isLast) => {

        if (item.is_departure_point) return this.utility.listStops[0].value;
        if (item.is_destination_point && isLast) return this.utility.listStops[6].value;
        return (item.type_of_stop != 0) ? item.stop : 'Border crossing'

    }

    doAllReturns = () => {
        let FN = [];
        this.timeTableList.map(rt => {
            if (rt.timetable_direction === 'Forward') FN.push(rt);// FN++;
        });
        let RN = [];
        this.timeTableList.map(rt => { if (rt.timetable_direction === 'Return') RN.push(rt); });

        let allIn = true;
        FN.forEach(fwr => {
            const val = RN.find(rtn => { return (rtn.timetable_pair_num == fwr.timetable_pair_num) });
            //console.log('Val : ', val);
            if (!val) {
                allIn = false;
            }

        })


        //console.log('FN : ', FN);
        //console.log('RN : ', RN);
        //console.log('All In : ', allIn);
        //console.log('Timetable : ', this.timeTableList);

        return allIn;
    }
}

// export class PermitTimetableComponent implements OnInit {
//     @Input() dataCntrl: any;
//     @Input() isApproval: boolean = false;
//
//     isLoading = false;
//     message = 'Loading timetables. Please wait...';
//     instructMsg = '';
//     departuresList: any = [];
//     departuresListRemove: any = [];
//     editFlag: boolean = false;
//     pageload: boolean = false;
//     showBlock: boolean = false;
//     isDuplicateMode: boolean = false;
//     isProcess: boolean = true;
//     timetableDirection: any = '';
//     timeTableTemplate: any;
//     timeTableDetail: any;
//
//     permitStatus13: any;
//     isExternalRole: boolean = true;
//
//     ///New Timetable
//
//     form;
//     routeLeg: any;
//     isCreated = true;
//     timetables: FormArray;
//     interval: any = [];
//     user = { LastName: '' };
//
//     ///End of Timetable
//
//     constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
//                 private showModal: PopupService, public applicationService: ApplicationService,
//                 private utility: UtilityServiceService,
//                 private router: Router, private permitService: PermitService, private authWebService: AuthWebService,
//                 private vehicleService: VehicleService, private toastService: ToastNotificationService,
//                 private activeRoute: ActivatedRoute, private placeService: PlaceService,
//                 private documenttypeService: DocumenttypeService, private timetblSrc: TimetableService,
//                 private routeService: RouteService, private countryService: CountryService, private datePipe: DatePipe) {
//         this.toastr.clear();
//
//     }
//
//     quillConfig = {
//         //toolbar: '.toolbar',
//         toolbar: {
//             container: [
//                 ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
//                 //['code-block'],
//                 [{'header': 1}, {'header': 2}],               // custom button values
//                 [{'list': 'ordered'}, {'list': 'bullet'}],
//                 [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
//                 [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
//                 [{'direction': 'rtl'}],                         // text direction
//
//                 ['clean'],                                         // remove formatting button
//
//                 ['link'],
//                 ['link', 'image', 'video']
//             ],
//
//         }
//
//     }
//
//     ngOnInit() {
//
//         if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
//             this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
//         }
//
//         this.timeTableTemplate = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'TimeTableTemplate').Value;
//
//         this.isDuplicateMode = this.router.url.indexOf('duplicate') > 0;
//         if (this.router.url.indexOf('view') > 0) {
//             this.isProcess = false;
//         }
//         if (this.router.url.indexOf('change') > 0) {
//             if (this.activeRoute.params['_value'].ctrlType != undefined && this.activeRoute.params['_value'].ctrlType == 'vehicle') {
//                 this.isDuplicateMode = true;
//             }
//         }
//
//         this.applicationService.getById(this.dataCntrl.application.id).subscribe(app => {
//             this.dataCntrl.application = app;
//             this.getTimeTable();
//         });
//
//         if (!this.authWebService.userData.Roles[0].IsExternalRole) {
//             this.isExternalRole = false;
//         }
//
//         this.initForm();
//
//     }
//
//     initForm() {
//         this.form = this.formBuilder.group({
//             id: [0, []]
//             , permit_id: [0, []]
//             , route_id: [0, []]
//             , timetable_direction: ['Forward', []]
//             , timetable_interval: ['', []]
//             , timetable_pair_num: [1, []]
//             , is_all: [false, []]
//             , is_for_day1: [false, []]
//             , is_for_day2: [false, []]
//             , is_for_day3: [false, []]
//             , is_for_day4: [false, []]
//             , is_for_day5: [false, []]
//             , is_for_day6: [false, []]
//             , is_for_day7: [false, []]
//             //borderCrossings: this.formBuilder.array([]),
//         });
//
//     }
//     onLoadTimetable = () => {
//         if (this.dataCntrl.timeId > 0) {
//             this.isCreated = false;
//             this.onSwitchOnOrOff(true);
//             this.message = 'Loading timetable, please wait...';
//             this.timetblSrc.getById(this.dataCntrl.timeId).subscribe((rsrc:any) => {
//                 //console.log('Timetable = ', rsrc);
//
//                 this.form.patchValue({
//                     id: rsrc.timetable.id
//                     //, permit_id: rsrc.timetable.permit_id
//                     , route_id: rsrc.timetable.route_id
//                     , timetable_direction: rsrc.timetable.timetable_direction
//                     , timetable_interval: rsrc.timetable.timetable_interval
//                     , timetable_pair_num: rsrc.timetable.timetable_pair_num
//                     , is_all: rsrc.timetable.is_all
//                     , is_for_day1: rsrc.timetable.is_for_day1
//                     , is_for_day2: rsrc.timetable.is_for_day2
//                     , is_for_day3: rsrc.timetable.is_for_day3
//                     , is_for_day4: rsrc.timetable.is_for_day4
//                     , is_for_day5: rsrc.timetable.is_for_day5
//                     , is_for_day6: rsrc.timetable.is_for_day6
//                     , is_for_day7: rsrc.timetable.is_for_day7
//                 });
//
//                 this.onSwitchOnOrOff();
//                 //this.toastr.success('Create Timetable', 'Timetable created successfully');
//
//             }, error => {
//                 //console.log('Form data = ', JSON.stringify(error));
//                 this.onSwitchOnOrOff();
//                 this.toastService.error('Failed to load timetable. If the problem persists, please contact system administrator.', 'Save Route');
//             });
//         }
//     }
//
//     getTimeTable() {
//         this.isLoading = true;
//         console.log('Timetable', this.dataCntrl.application.timeTableDetail)
//         if (this.dataCntrl.application.timeTableDetail == null || this.dataCntrl.application.timeTableDetail == undefined || this.dataCntrl.application.timeTableDetail == '' || this.dataCntrl.application.timeTableDetail === '') {
//             this.timeTableDetail = this.dataCntrl.application.timeTableDetail = this.timeTableTemplate;
//         } else {
//             this.timeTableDetail = this.dataCntrl.application.timeTableDetail;
//         }
//         this.isLoading = false;
//
//     }
//
//     @Output() previousStep = new EventEmitter<number>();
//
//     goBack() {
//         this.previousStep.emit(5);
//     }
//
//     @Output() nextStep = new EventEmitter<number>();
//
//     goNextStep() {
//         this.nextStep.emit(5);
//     }
//
//     async saveTable() {
//         this.message = 'Saving TimeTable, Please wait...';
//         this.isLoading = true;
//         this.dataCntrl.application.timeTableDetail = this.timeTableDetail;
//         //this.dataCntrl.application.timeTableDetailImg = await this.convertTabletoImage(this.timeTableDetail);
//         //alert(JSON.stringify(this.dataCntrl.application.timeTableDetailImg));
//
//         if (this.router.url.indexOf('duplicate') > 0 && this.router.url.indexOf('edit') < 0) {
//             //console.log("duplicated");
//             //console.log(this.dataCntrl.application);
//             this.applicationService.putApplicationDuplicate(this.dataCntrl.application)
//                 .subscribe((result: any) => {
//                         this.dataCntrl.application = result;
//                         // this.saveDepatureDestination();
//                         this.toastService.success('Application duplicated successfully', 'Duplicate Application');
//                         let url: any = 'carrier/permit/application/duplicate/edit/' + result.id;
//                         this.router.navigate([url]);
//                     },
//                     error => {
//                         this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
//
//                         // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
//                         return;
//                     });
//         }
//         if (this.router.url.indexOf('correction') > 0) {
//             return this.applicationService.setTab(7);
//         } else {
//
//
//             console.log(this.dataCntrl.application);
//             this.applicationService.putApplication(this.dataCntrl.application).subscribe(x => {
//                 this.toastService.success('Timetable Saved!', 'Save Application');
//                 this.isLoading = false;
//             });
//             if (!this.isApproval) {
//                 this.applicationService.setTab(6);
//                 document.getElementById('timetable-stepper-next').click();
//             }
//         }
//     }
//
//     replaceWith(theTable): any {
//         console.log(theTable);
//         var html = '';
//
//
//         $('tr', theTable).each(function () {
//             html += '<div>';
//             $('th', this).each(function () {
//                 html += '<div>' + $(this).html() + '</div>';
//             });
//             $('td', this).each(function () {
//                 html += '<div>' + $(this).html() + '</div>';
//             });
//             html += '</div>';
//         });
//
//
//         html.replace('&nbsp;', '');
//         return '<div>' + html + '</div>';
//     }
//
//     cancelApplication() {
//         let prevUrl = localStorage.getItem('previousUrl');
//         if (prevUrl.search('/permit/approval') != -1) {
//             this.router.navigate(['/permit/approval/']);
//         } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
//             this.router.navigate(['/carrier/permit/application/mypermits/', this.dataCntrl.carrierID]);
//         } else {
//             this.router.navigate(['/carrier/permit/application/', this.dataCntrl.carrierID]);
//         }
//     }
//
//     createElementFromHTML(htmlString): HTMLDivElement {
//
//         var div = document.createElement('div');
//         div.setAttribute('id', 'test');
//
//         div.innerHTML = htmlString.trim();
//         // Change this to div.childNodes to support multiple top-level nodes
//         return div;
//     }
//
//     async convertTabletoImage(theTable): Promise<string> {
//
//         var node = this.createElementFromHTML(theTable);
//
//         //console.log(node);
//         //alert(JSON.stringify(node));
//         let myImageBlob: any;
//
//         //console.log(node);
//         var cbe = document.getElementById('test');
//         // console.log(cbe);
//         // console.log(document.body);
//         // console.log($('div#test2').get[0]);
//         await this.getScreenshotOfElement($('div#test2').get[0], 0, 0, 100, 100, function (data) {
//             // in the data variable there is the base64 image
//             // exmaple for displaying the image in an <img>
//             myImageBlob = data;
//         });
//
//
//         console.log(myImageBlob);
//         var theImage = myImageBlob;//.src.replace("data&colon;image/png;base64,","");
//         return theImage;
//
//
//     }
//
//     async getScreenshotOfElement(element, posX, posY, width, height, callback) {
//         console.log(element);
//         await html2canvas(element, {
//             width: width,
//             height: height,
//             useCORS: true,
//         }).then(canvas => {
//             var imgData = canvas.toDataURL();
//             // alert(imgData);
//             callback(imgData.replace('data:image/png;base64,', ''));
//
//         });
//         // await  html2canvas(element, {
//         //     width: width,
//         //     height: height
//         //   }).then(canvas =>{
//         //     alert(1);
//         //     var imgData = canvas.toDataURL("image/png");
//
//         //       var context = canvas.getContext('2d');
//         //       var imageData = context.getImageData(posX, posY, width, height).data;
//         //       var outputCanvas = document.createElement('canvas');
//         //       var outputContext = outputCanvas.getContext('2d');
//         //       outputCanvas.width = width;
//         //       outputCanvas.height = height;
//         //       alert(2);
//         //       var idata = outputContext.createImageData(width, height);
//         //       idata.data.set(imageData);
//         //       outputContext.putImageData(idata, 0, 0);
//         //       callback(outputCanvas.toDataURL().replace("data:image/png;base64,", ""));
//
//         //   });
//     }
//
//
//     backToTab() {
//         this.applicationService.setTab(4);
//         document.getElementById('timetable-stepper-prev').click();
//     }
//
//     //New Timetable Application
//
//     onSwitchOnOrOff = (state = false) => {
//         this.isLoading = state;
//     }
//
//     onSubmit = (form: any) => {
//         ////console.log('Index 2 = ', this.dataCntrl.index);
//         form.timetable_interval = this.setInterval();
//         if (this.dataCntrl.isReturned) {
//
//             ////console.log('Timetable ID: ', this.dataCntrl.timeId);
//             this.onCreateReturnTimetable(form);
//         } else {
//             if (this.dataCntrl.timeId > 0) {
//                 this.onSwitchOnOrOff(true);
//                 this.message = 'Updating timetable, please wait...';
//                 form.user_modified = this.user.LastName;
//                 form = { timetable: form };
//                 this.timetblSrc.update(form).subscribe(rsrc => {
//                     ////console.log('Updated data = ', rsrc);
//                     this.onSwitchOnOrOff();
//                     $("#timeBtn").click();
//                     this.toastService.success('Timetable updated successfully', 'Update Timetable');
//                     this.onClose();
//                     this.dataCntrl.timeId = 0;
//                 }, error => {
//                     this.onSwitchOnOrOff();
//                     this.toastService.error('Failed to update timetable. If the problem persists, please contact system administrator.', 'Update Timetable');
//                     this.onClose();
//                     this.dataCntrl.timeId = 0;
//                 });
//             } else {
//                 form.timetable_pair_num = this.dataCntrl.index;
//                 form.route_id = this.dataCntrl.application.route_id;
//                 // alert(JSON.stringify( this.dataCntrl.application.permits));
//                 // this.dataCntrl.application.permits.forEach(permit => {
//                 //   form.permit_id.push(permit.id);
//                 // });
//
//                 form.user_created = form.user_modified = this.user.LastName;
//                 this.onSwitchOnOrOff(true);
//                 this.message = 'Creating timetable, please wait...';
//                 form = { timetable: form };
//                 this.timetblSrc.add(form).subscribe(rsrc => {
//                     ////console.log('Saved data = ', rsrc);
//                     this.onSwitchOnOrOff();
//                     $("#timeBtn").click();
//                     this.toastService.success('Timetable created successfully', 'Create Timetable');
//                     setTimeout(() => {
//                         this.toastr.clear();
//                         clearTimeout();
//                     }, 3000);
//                     $("#timeBtn").click();
//                     this.onClose();
//                 }, error => {
//                     this.onSwitchOnOrOff();
//                     this.toastService.error('Failed to create timetable. If the problem persists, please contact system administrator.', 'Create Timetable');
//                     this.onClose();
//                 });
//             }
//         }
//
//     }
//
//
//     createTimetableLegs(leg: any = null): FormGroup {
//         return this.formBuilder.group({
//             legId: 0,
//             placeFrom: 0,
//             placeTo: 0,
//             stepNum: 1,
//             routeType: 0,
//             stopType: 0,
//             station_from: null,
//             station_to: null,
//             country_from: '',
//             country_to: '',
//             timetableLeg_id: 0,
//             timetable_id: 0,
//             depart_time: null,
//             arrive_time: null,
//             duration: null
//         });
//     }
//
//     addRouteLegs(legs: any): void {
//         this.timetables = this.form.get('timetables') as FormArray;
//         let start = legs[0];
//         let current: any;
//         legs.forEach(leg => {
//             if (leg.stepNum > 1) {
//                 this.timetables.push(this.formBuilder.group({
//                     legId: leg.legId,
//                     placeFrom: leg.placeFrom,
//                     placeTo: leg.placeTo,
//                     stepNum: leg.stepNum,
//                     routeType: leg.routeType,
//                     stopType: leg.stopType,
//                     station_from: leg.station_from,
//                     station_to: leg.station_to,
//                     country_from: leg.country_from,
//                     country_to: leg.country_to,
//                     timetableLeg_id: leg.timetableLeg_id,
//                     timetable_id: leg.timetable_id,
//                     depart_time: leg.depart_time,
//                     arrive_time: leg.arrive_time,
//                     duration: leg.duration
//                 }));
//                 start = leg;
//             } else {
//                 this.form.patchValue({ first_place_leg_id: leg.legId });
//             }
//         })
//
//     }
//
//
//     isAll = (event: any) => {
//         if (event.currentTarget.checked) {
//             this.form.patchValue({
//                 is_for_day1: true
//                 , is_for_day2: true
//                 , is_for_day3: true
//                 , is_for_day4: true
//                 , is_for_day5: true
//                 , is_for_day6: true
//                 , is_for_day7: true
//             });
//             //this.interval.push(['Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays', 'Sundays']);
//         } else {
//             this.form.patchValue({
//                 is_for_day1: false
//                 , is_for_day2: false
//                 , is_for_day3: false
//                 , is_for_day4: false
//                 , is_for_day5: false
//                 , is_for_day6: false
//                 , is_for_day7: false
//             });
//             this.interval = [];
//         }
//         //console.log('Interval = ', this.interval.toString());
//     }
//
//     setInterval = () => {
//         this.interval = [];
//         const isAll = this.form.get('is_all').value;
//         if (isAll) {
//             this.interval.push('Daily');
//
//         } else {
//
//             const intervals = [
//                 { key: this.form.get('is_for_day1').value, value: 'Mondays' },
//                 { key: this.form.get('is_for_day2').value, value: 'Tuesdays' },
//                 { key: this.form.get('is_for_day3').value, value: 'Wednesdays' },
//                 { key: this.form.get('is_for_day4').value, value: 'Thursdays' },
//                 { key: this.form.get('is_for_day5').value, value: 'Fridays' },
//                 { key: this.form.get('is_for_day6').value, value: 'Saturdays' },
//                 { key: this.form.get('is_for_day7').value, value: 'Sundays' }
//             ];
//
//             intervals.forEach(elm => {
//                 if (elm.key == true) {
//                     this.interval.push(elm.value);
//                 }
//             });
//         }
//         //this.form.patchValue({ 'timetable_interval': this.interval.toString()});
//
//
//
//         ////console.log('Interval = ', this.interval.toString());
//         return this.interval.toString();
//
//
//     }
//
//     unSelectAll() {
//         const intervals = [
//             this.form.get('is_for_day1').value,
//             this.form.get('is_for_day2').value,
//             this.form.get('is_for_day3').value,
//             this.form.get('is_for_day4').value,
//             this.form.get('is_for_day5').value,
//             this.form.get('is_for_day6').value,
//             this.form.get('is_for_day7').value
//         ];
//         const isAll = (intervals.indexOf(false) == -1) ? true : false;
//         this.form.patchValue({ is_all: (isAll) ? true : false });
//     }
//
//
//     onClose = () => {
//         // $("#Manager").modal('hide');
//     }
//
//     isValidForm = () => {
//         const intervals = [
//             this.form.get('is_for_day1').value,
//             this.form.get('is_for_day2').value,
//             this.form.get('is_for_day3').value,
//             this.form.get('is_for_day4').value,
//             this.form.get('is_for_day5').value,
//             this.form.get('is_for_day6').value,
//             this.form.get('is_for_day7').value
//         ];
//         return (intervals.indexOf(true) > -1) ? true : false;
//
//     }
//
//     onCreateReturnTimetable = (form: any) => {
//         form.user_created = form.user_modified = this.user.LastName;
//         form.timetable_direction = "Return"
//         this.onSwitchOnOrOff(true);
//         this.message = 'Creating return timetable, please wait...';
//         form = { timetable: form };
//         this.timetblSrc.createReturn(form).subscribe((rsrc:any) => {
//             //console.log('created Return = ', rsrc);
//             this.onSwitchOnOrOff();
//             if (rsrc.isCreated) {
//                 $("#timeBtn").click();
//                 this.toastService.success('Return timetable created successfully', 'Create Return Timetable');
//                 setTimeout(() => {
//                     this.toastr.clear();
//                     clearTimeout();
//                 }, 4000);
//             } else {
//                 this.toastService.error("The timetable can't be used to create a return timetable.", 'Create Return Timetable');
//             }
//             this.onClose();
//         }, error => {
//             this.onSwitchOnOrOff();
//             this.toastService.error('Failed to create return timetable. If the problem persists, please contact system administrator.', 'Create Return Timetable');
//             this.onClose();
//         });
//
//     }
// }
